export const templateTextWidget = `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <title>Iniya Voice Chat Widget</title>
  <style>
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');

    :host { font-family: 'Inter', sans-serif; }
    body { font-family: 'Inter', sans-serif; background: linear-gradient(to bottom right, #ebf8ff, #e0e7ff); min-height: 100vh; padding: 1rem; margin: 0; }
    .chat-widget { background: #fff; border-radius: 1rem; width: 100%; max-width: 400px; height: 600px; display: flex; flex-direction: column; overflow: hidden; position: fixed; bottom: 6rem; right: 1.5rem; z-index: 1000; box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25); }
    .widget-header { background: linear-gradient(to right, #2563eb, #7c3aed); padding: 1rem; display: flex; align-items: center; justify-content: space-between; }
    .header-left { display: flex; align-items: center; gap: 0.75rem; }
    .icon-circle { width: 2.5rem; height: 2.5rem; background: rgba(255, 255, 255, 0.2); border-radius: 9999px; display: flex; align-items: center; justify-content: center; }
    .icon-circle svg { width: 1.5rem; height: 1.5rem; color: #fff; }
    .widget-title { color: #fff; font-weight: 600; margin: 0; }
    .widget-subtitle { color: rgba(255, 255, 255, 0.8); font-size: 0.875rem; margin: 0; }
    .minimize-btn svg { width: 1.25rem; height: 1.25rem; color: rgba(255, 255, 255, 0.8); cursor: pointer; }
    .minimizing { opacity: 1; transform: translateY(0px); animation: slideDown 0.3s ease-in forwards; }
    @keyframes slideDown { to { transform: translateY(20px); opacity: 0; } }
    .voice-area { flex: 1; padding: 1.5rem; background: #f9fafb; display: flex; flex-direction: column; align-items: center; justify-content: center; }
    .ai-avatar { width: 8rem; height: 8rem; background: linear-gradient(to bottom right, #60a5fa, #8b5cf6); border-radius: 9999px; display: flex; align-items: center; justify-content: center; margin-bottom: 1.5rem; transition: all 0.3s ease; }
    .ai-avatar svg { width: 4rem; height: 4rem; color: #fff; }
    .status-text h3 { font-size: 1.25rem; font-weight: 600; color: #1f2937; margin-bottom: 0.5rem; text-align: center; }
    .status-text p { color: #4b5563; margin: 0; text-align: center; }
    
    .voice-controls { padding: 1.5rem; background: #fff; border-top: 1px solid #e5e7eb; }
    .voice-btn { width: 4rem; height: 4rem; background: linear-gradient(to right, #2563eb, #7c3aed); color: #fff; border: none; border-radius: 9999px; display: flex; align-items: center; justify-content: center; margin: 0 auto 1rem; cursor: pointer; transition: all 0.2s ease; }
    .voice-btn:hover { box-shadow: 0 0 10px rgba(76, 29, 149, 0.3); transform: scale(1.05); }
    .voice-btn svg { width: 2rem; height: 2rem; }
    .voice-btn.active { background: #dc2626; }
    .voice-btn.active:hover { box-shadow: 0 0 12px rgba(220, 38, 38, 0.4); transform: scale(1.05); }
    .control-buttons { display: flex; justify-content: center; gap: 1rem; }
    .control-button { padding: 0.75rem; background: #f3f4f6; border-radius: 9999px; transition: background 0.2s ease; cursor: pointer; }
    .control-button:hover { background: #e5e7eb; }
    .control-button svg { width: 1.25rem; height: 1.25rem; color: #374151; }
    .status-indicator { text-align: center; margin-top: 1rem; }
    .status-indicator p { font-size: 0.875rem; color: #6b7280; }
    .floating-button { position: fixed; bottom: 1.5rem; right: 1.5rem; z-index: 50; }
    .voice-floating-btn { background: linear-gradient(to right, #2563eb, #7c3aed); color: #fff; padding: 1rem; border: none; border-radius: 9999px; box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.25), 0 10px 10px -5px rgba(0, 0, 0, 0.04); cursor: pointer; transition: all 0.2s ease; }
    .voice-floating-btn:hover { box-shadow: 0 30px 60px -10px rgba(0, 0, 0, 0.3), 0 15px 20px -5px rgba(0, 0, 0, 0.05); transform: scale(1.1); }
    .button-content { display: flex; align-items: center; gap: 0.25rem; }
    .icon-small { width: 1.25rem; height: 1.25rem; }
    .button-text { font-size: 0.75rem; font-weight: 500; }
    .voice-waves { display: flex; align-items: flex-end; gap: 4px; margin-bottom: 1.5rem; height: 2rem; margin-top:2em; }
    .wave { width: 4px; background-color: #3B82F6; border-radius: 9999px;   }
    @keyframes bounce { 0%, 100% { height: 20%; } 50% { height: 100%; } }
    .hidden { display: none; }

    @media screen and (max-width: 800px){.chat-widget{width:88%;height:auto;}}


  </style>
</head>
<body>
  <div id="chatWidget" class="chat-widget hidden">
    <div class="widget-header">
      <div class="header-left">
        <div class="icon-circle">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z" />
          </svg>
        </div>
        <div>
          <h3 class="widget-title">Iniya</h3>
          <p class="widget-subtitle">Your AI Voice Agent</p>
        </div>
      </div>
      <div id="minimize-btn" class="minimize-btn">
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M19 9l-7 7-7-7" />
        </svg>
      </div>
    </div>

    <div class="voice-area">
      <div class="ai-avatar">
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z" />
        </svg>
      </div>
      <div class="status-text">
        <h3>Hi! I'm Iniya</h3>
        <p>Tap the microphone to start talking</p>
      </div>

       <!-- Voice Waves Visualization -->
      <div  class="voice-waves hidden">
        <div class="wave" style="animation-delay: 0s;"></div>
        <div class="wave" style="animation-delay: 0.1s;"></div>
        <div class="wave" style="animation-delay: 0.2s;"></div>
        <div class="wave" style="animation-delay: 0.3s;"></div>
        <div class="wave" style="animation-delay: 0.4s;"></div>
        <div class="wave" style="animation-delay: 0.5s;"></div>
        <div class="wave" style="animation-delay: 0.6s;"></div>
      </div>

    </div>

    <div class="voice-controls">
      <button id="voice-btn" class="voice-btn">
        <svg class="start-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z" />
        </svg>

        <svg class="stop-icon hidden" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <line x1="6" y1="6" x2="18" y2="18" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
          <line x1="6" y1="18" x2="18" y2="6" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
        </svg>



      </button>
  
      <div class="status-indicator">
        <p id="status-message">Ready to listen</p>
      </div>
    </div>
  </div>
  <!-- Floating Voice Button (for when minimized) -->
<div id="floatingBtn" class="floating-button ">
  <button id="voice-floating-btn" class="voice-floating-btn">
    <div class="button-content">
      <svg class="icon-small" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z">
        </path>
      </svg>
      <span class="button-text">Voice</span>
    </div>
  </button>
</div>

</body>
</html>

`;
